(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.app = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var MESSAGE_TYPES = exports.MESSAGE_TYPES = ['success', 'error', 'warning'];
  var DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
    autoHide: false,
    autoHideDelay: 3000
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/klicknotify/lib/config/app.js
// module id = 249
// module chunks = 0